import React from 'react';
import { useLocation } from 'react-router-dom';

import Sidebar from '../Sidebar';
import SideBarGerencial from '../SideBarGerencial/SideBarGerencial';
import SideBarFinancas from '../SideBarFinancas/SideBarFinancas';
import SideBarAppCli from '../SideBarAppCli/SideBarAppCli';
import SideBarAdmAppCli from '../SideBarAdmAppCli';
import SideBarFrotas from '../SideBarFrotas';
import SideBarCRM from '../SideBarCRM';
import SideBarAdmPartner from '../SideBarAdmPartner';
import SideBarPartner from '../SideBarPartner'; // importar o sidebar do partner comum

import {
  AMODULO_FINANCAS,
  AMODULO_GERENCIAL,
  AMODULO_FRONT,
  AMODULO_SISAREPASSENGER,
  AMODULO_ADMAPPCLI,
  AMODULO_FROTAS,
  AMODULO_CRM,
  AMODULO_PARTNER
} from 'consts';

const ChosenBar = (props) => {
  const { onClose, variant, modulo, open } = props;
  const location = useLocation();

  console.log('modulo:', modulo);
  console.log('rota atual:', location.pathname);

console.log('modulo:', modulo);
console.log('modulo parseado:', parseInt(modulo, 10));
console.log('AMODULO_GERENCIAL:', AMODULO_GERENCIAL);
console.log('rota atual:', location.pathname);

  let componenteRenderizado;

  switch (parseInt(modulo, 10)) {
    case AMODULO_FRONT:
      componenteRenderizado = (
        <Sidebar
          onClose={onClose}
          open={open}
          variant={variant}
        />
      );
      break;

    case AMODULO_FINANCAS:
      componenteRenderizado = (
        <SideBarFinancas
          onClose={onClose}
          open={open}
          variant={variant}
        />
      );
      break;

    case AMODULO_GERENCIAL:
      componenteRenderizado = (
        <SideBarGerencial
          onClose={onClose}
          open={open}
          variant={variant}
        />
      );
      break;

    case AMODULO_SISAREPASSENGER:
      componenteRenderizado = (
        <SideBarAppCli
          onClose={onClose}
          open={open}
          variant={variant}
        />
      );
      break;

    case AMODULO_ADMAPPCLI:
      componenteRenderizado = (
        <SideBarAdmAppCli
          onClose={onClose}
          open={open}
          variant={variant}
        />
      );
      break;

    case AMODULO_FROTAS:
      componenteRenderizado = (
        <SideBarFrotas
          onClose={onClose}
          open={open}
          variant={variant}
        />
      );
      break;

    case AMODULO_CRM:
      componenteRenderizado = (
        <SideBarCRM
          onClose={onClose}
          open={open}
          variant={variant}
        />
      );
      break;

    case AMODULO_PARTNER:
      if (location.pathname.startsWith('/admpartner')) {
        componenteRenderizado = (
          <SideBarAdmPartner
            onClose={onClose}
            open={open}
            variant={variant}
          />
        );
      } else if (location.pathname.startsWith('/partner')) {
        componenteRenderizado = (
          <SideBarPartner
            onClose={onClose}
            open={open}
            variant={variant}
          />
        );
      } else {
        componenteRenderizado = <div>menu partner não identificado</div>;
      }
      break;

    default:
      componenteRenderizado = <div>nenhum menu selecionado</div>;
      break;
  }

  return <div>{componenteRenderizado}</div>;
};

export default ChosenBar;